export const STUDY_ADMIN = "StudyAdmin";
export const SYSTEM_ADMIN = "SystemAdmin";
export const SPONSOR = "Sponsor";
export const SUB_PI = "SubPi";
export const STUDY_COORDINATOR = "StudyCoordinator";
export const BIOSTATICS = "Biostatics";
export const AUDITOR = "Auditor";
export const RESEARCH_ASSOCIATE = "ResearchAssociate";
export const PI = "Pi";
export const CRA = "Cra";
export const CraUB = "CraUB";
export const DM = "Dm";
export const QUALITY = "Quality";
export const HOME_HEALTH = "HomeHealth";
export const participantStatuses = {
  VERIFIED: "VERIFIED",
  INVITED: "INVITED",
  WITHDRAWCONSENT: "WITHDRAWCONSENT",
  DISQUALIFIED: "DISQUALIFIED",
  WITHDRAWSTUDY: "WITHDRAWSTUDY",
  ACTIVE: "ACTIVE",
  NOTINVITED: "NOTINVITED",
  REGISTERED: "REGISTERED",
  PRESCREENED: "PRESCREENED",
  SCREENPASSED: "SCREENPASSED",
  SCREENING: "SCREENING",
  RANDOMIZED: "RANDOMIZED",
  SCREENFAILED: "SCREENFAILED",
  ACTIVEWMODIFICATION: "ACTIVEWMODIFICATION",
  ACTIVEWITHOUTAPP: "ACTIVEWITHOUTAPP",
  DISCONTINUED: "DISCONTINUED"
};
export const participantStatusesText = {
  VERIFIED: "Verified",
  INVITED: "Invited",
  WITHDRAWCONSENT: "Withdrawn consent",
  DISQUALIFIED: "Disqualified",
  WITHDRAWSTUDY: "Withdrawn",
  ACTIVE: "Active",
  NOTINVITED: "Imported",
  REGISTERED: "Registered",
  PRESCREENED: "Prescreened",
  SCREENPASSED: "Screen Passed",
  SCREENING: "Screening",
  RANDOMIZED: "Randomized",
  SCREENFAILED: "Screening Failed",
  ACTIVEWMODIFICATION: "Active with modifications",
  ACTIVEWITHOUTAPP: "Active without App",
  DISCONTINUED: "Discontinued"
};
export const participantSourcesText = {
  APP: "App",
  WEB: "Web",
  MANUAL: "Manual"
};
export const participantSources = { APP: "APP", WEB: "WEB", MANUAL: "MANUAL" };
export const participantLanguageText = { EN: "English" };
export const SITEDATALOCK = "SiteDataLock";
export const STUDY_MANAGER = "StudyManager";
export const INTERVIEWER = "Interviewer";
export const RATER = "Rater";
export const BSTAT = "Biostatistics";
export const PHV = "Pharmacovigilance";
export const CC = "CallCenter";
export const SUPPORT = "Support";

export const RoleStore = {
  PLATFORM_ROLES: "roles",
  SITE_ROLES: "site-roles"
};

export const TypeOfRole = {
  ADMIN: "ADMIN",
  SITE_TEAM: "SITE_TEAM",
  STUDY_TEAM: "STUDY_TEAM",
  ALL: ""
};
